// Shared chrome for the public legal / FAQ pages: top brand bar, container,
// footer with cross-links. Uses the same publicLanding endpoint so the
// hospital's brand stays consistent across the public surface.

import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../lib/api.js';

export default function LegalLayout({ title, lastUpdated, children }) {
  const [params] = useSearchParams();
  const code = params.get('fac') || params.get('code') || null;

  const [b, setB] = useState({
    display_name: 'Meds-to-Beds',
    theme_primary: '#1d4ed8',
    logo_url: null,
  });

  useEffect(() => {
    let alive = true;
    api.publicLanding(code)
      .then(r => { if (alive && r.landing) setB(prev => ({ ...prev, ...r.landing })); })
      .catch(() => {});
    return () => { alive = false; };
  }, [code]);

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-6 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            {b.logo_url
              ? <img src={b.logo_url} alt="" className="h-8 w-8 rounded" />
              : <div className="h-8 w-8 rounded" style={{ background: b.theme_primary }} />
            }
            <span className="font-semibold text-slate-800">{b.display_name}</span>
          </Link>
          <nav className="flex gap-4 text-sm text-slate-600">
            <Link to="/help/faq" className="hover:text-slate-900">FAQ</Link>
            <Link to="/legal/privacy" className="hover:text-slate-900">Privacy</Link>
            <Link to="/legal/terms" className="hover:text-slate-900">Terms</Link>
            <Link to="/login" className="font-medium" style={{ color: b.theme_primary }}>Sign in</Link>
          </nav>
        </div>
      </header>

      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-6 py-10">
          <h1 className="text-3xl font-bold text-slate-900">{title}</h1>
          {lastUpdated && (
            <div className="text-xs text-slate-500 mt-1">Last updated: {lastUpdated}</div>
          )}
          <article
            className="mt-6 bg-white border border-slate-200 rounded-lg p-6 prose prose-slate max-w-none
                       prose-h2:text-lg prose-h2:font-semibold prose-h2:mt-6 prose-h2:mb-2
                       prose-p:text-slate-700 prose-li:text-slate-700 prose-a:text-[var(--brand-primary)]"
          >
            {children}
          </article>
        </div>
      </main>

      <footer className="border-t border-slate-200 bg-white">
        <div className="max-w-6xl mx-auto px-6 py-6 flex flex-wrap gap-x-6 gap-y-2 text-xs text-slate-500 justify-between">
          <div>© {new Date().getFullYear()} {b.display_name}. For demo / educational use.</div>
          <div className="flex gap-4">
            <Link to="/legal/terms"   className="hover:text-slate-700">Terms of Use</Link>
            <Link to="/legal/privacy" className="hover:text-slate-700">Privacy Notice</Link>
            <Link to="/help/faq"      className="hover:text-slate-700">FAQ &amp; Help</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
